const eurFmt = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 2 });
const eurFineFmt = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 4 });
// AI costs are tracked in USD (OpenAI list prices, no conversion). Shop prices
// stay in EUR via the eur* formatters above.
const usdFmt = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'USD', currencyDisplay: 'narrowSymbol', maximumFractionDigits: 2 });
const usdFineFmt = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'USD', currencyDisplay: 'narrowSymbol', minimumFractionDigits: 2, maximumFractionDigits: 4 });
const intFmt = new Intl.NumberFormat('it-IT');
const decFmt = new Intl.NumberFormat('it-IT', { minimumFractionDigits: 1, maximumFractionDigits: 2 });
const pctFmt = new Intl.NumberFormat('it-IT', { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1 });
const dateShortFmt = new Intl.DateTimeFormat('it-IT', { day: '2-digit', month: 'short' });
const dateFullFmt = new Intl.DateTimeFormat('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });
const dateTimeFmt = new Intl.DateTimeFormat('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });

export const fmt = {
  eur: (n) => eurFmt.format(Number(n) || 0),
  eurFine: (n) => eurFineFmt.format(Number(n) || 0),
  usd: (n) => usdFmt.format(Number(n) || 0),
  usdFine: (n) => usdFineFmt.format(Number(n) || 0),
  int: (n) => intFmt.format(Number(n) || 0),
  dec: (n) => decFmt.format(Number(n) || 0),
  pct: (n) => pctFmt.format(Number(n) || 0),
  shortDate: (d) => (d ? dateShortFmt.format(new Date(d)) : ''),
  date: (d) => (d ? dateFullFmt.format(new Date(d)) : ''),
  dateTime: (d) => (d ? dateTimeFmt.format(new Date(d)) : ''),
  durationMs: (ms) => {
    const v = Number(ms) || 0;
    if (v < 1000) return `${Math.round(v)} ms`;
    if (v < 60_000) return `${(v / 1000).toFixed(1)} s`;
    return `${Math.round(v / 60_000)} min`;
  }
};
